export const STORE_KEY = 'learningUnits';
